module.exports = __webpack_public_path__ + "img/mm-icon.993f4abc.svg";